import FakeTextCursor from './FakeTextCursor';
export default FakeTextCursor;
